module.exports = __webpack_public_path__ + "static/media/s4-alt.bba24610.png";